import { RichText, DateField } from '@sitecore-jss/sitecore-jss-react';
import React, { FC } from 'react';
import { iconSize } from '../../../../constants/icon.constants';
import { googleLatestUpdatesClickEvent } from '../../../../utils/analytics';
import Icon from '../../../@shared/icon';
import Picture from '../../../@shared/picture';
import StyledLink from '../../../@shared/styledLink';
import { TNewsCardContent } from './types/newsCard.types';
import useFormatDate from '../../../../hooks/useFormatDate';

const NewsCardContent: FC<TNewsCardContent> = (props) => {
  const { desktopCardImage, mobileCardImage, formatDate, title, subtitle, link, isEE, cardHeadingTitleTag } = props;
  const formattedDate = useFormatDate(formatDate?.value);

  return (
    <>
      <Picture
        editorialImageProps={{
          desktopImage: desktopCardImage,
          mobileImage: mobileCardImage,
          desktopTransformation: 'Size500',
          mobileTransformation: 'Size300',
          cssClassPictureEl: 'case-news-card__img-container',
        }}
      />
      {formatDate && <DateField field={{ value: formattedDate }} tag="p" className="case-news-card__publish-date" />}
      <RichText tag={cardHeadingTitleTag} field={title} className="case-news-card__title" />
      <RichText tag="div" field={subtitle} className="case-news-card__subtitle rich-text" />
      <div className="case-news-card__cta">
        {isEE ? (
          <StyledLink field={link} />
        ) : (
          link?.value?.text && (
            <span
              className="link-with-arrow"
              onClick={() => googleLatestUpdatesClickEvent(title?.value, link?.value?.href, link?.value?.text)}
            >
              {link?.value?.text}
              <Icon iconName="arrow-chevron-right" color="primary" size={iconSize.tbl} />
            </span>
          )
        )}
      </div>
    </>
  );
};

export default NewsCardContent;
